import React from "react";
import { useReveal } from "@/hooks/useReveal";

const STUDIOS = [
  {
    id: "mat-yoga",
    name: "Mat & Yoga Studio",
    address: "Rua da Caridade nº 80",
    city: "2330-109 Entroncamento",
    area: "70 m²",
    note: "Aulas de tapete, yoga e práticas em grupo, numa sala em luz natural.",
    image: "/media/luft-mat-yoga-studio.jpg",
  },
  {
    id: "reformer-privados",
    name: "Reformer Studio",
    address: "Av. José Eduardo Vítor das Neves nº 79A",
    city: "2330-066 Entroncamento",
    area: "130 m²",
    note: "Sala equipada com aparelhos Merrithew, para sessões em grupo reduzido ou individuais, num ambiente intimista.",
    image: "/media/luft-reformer-studio.jpg",
  },
];

export default function Studios() {
  const ref = useReveal();

  return (
    <section
      id="estudios"
      ref={ref}
      className="relative bg-[var(--luft-bg)] py-32 sm:py-44 lg:py-52"
      data-testid="studios-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-4xl mb-24 sm:mb-32 reveal">
          <p className="eyebrow mb-8">06 — Os Estúdios</p>
          <h2 className="editorial-heading text-[clamp(2.2rem,5.4vw,4.4rem)] text-[var(--luft-ink)]">
            Duas casas,<br />
            um mesmo <em className="editorial-italic">silêncio</em>.
          </h2>
          <p className="mt-8 font-body font-light text-[var(--luft-ink-soft)] text-base leading-relaxed max-w-lg">
            O Lu.ft vive em dois espaços, pensados separadamente para cada prática.
            Mantemos a mesma atenção em ambos: luz, materiais cuidados e um ritmo próprio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-24">
          {STUDIOS.map((s) => (
            <article
              key={s.id}
              className="reveal group"
              data-testid={`studio-${s.id}`}
            >
              <div className="aspect-[4/5] overflow-hidden bg-[var(--luft-bg-alt)]" style={{ borderRadius: "var(--radius-organic)" }}>
                <img
                  src={s.image}
                  alt={s.name}
                  className="w-full h-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-[1.03]"
                  loading="lazy"
                />
              </div>

              <div className="mt-10">
                <h3 className="editorial-heading text-3xl sm:text-4xl text-[var(--luft-ink)]">
                  {s.name}
                </h3>
                <div className="mt-6 font-body font-light text-[var(--luft-ink)] text-base leading-relaxed">
                  <p>{s.address}</p>
                  <p>
                    {s.city}
                    {s.area && (
                      <span className="text-[var(--luft-ink-soft)]"> · {s.area}</span>
                    )}
                  </p>
                </div>
                <p className="mt-6 font-body font-light text-[var(--luft-ink-soft)] text-sm leading-relaxed max-w-sm">
                  {s.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
